import { Button, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { text as textColor } from "../../../theme/colours";

const BackButton = ({ text, goBack }) => {
  const backBtn = {
    display: "flex",
    alignItems: "center",
    width: "fit-content",
    mb: "2rem",
    padding: "0",
    background: "none",
    textTransform: "none",
    color: textColor.primary,
  };
  const arrowIconStyle = {
    fontSize: "1rem",
    color: textColor.primary,
    mr: "0.75rem",
  };

  return (
    <Button sx={backBtn} onClick={goBack}>
      <ArrowBackIcon sx={arrowIconStyle} />
      <Typography variant="h3">{text}</Typography>
    </Button>
  );
};

export default BackButton;
